export default __webpack_public_path__ + "static/media/anh dashboard.644d5ff9.svg";